export default __webpack_public_path__ + "5585d78f8bbd0edf1e30153c2f6da6c3.png";